import BlockAcademicOffer from "../components/BlockAcademicOffer";
import FixedHeader from "../components/FixedHeader";
import BannerGeneral from "../components/BannerGeneral";
import BlockLeftImage from "../components/BlockLeftImage";
import DataFetcherTemplate from "../hooks/fetchTemplate";
import Card from "../components/Card";
import DataDisplayOtrasFormas from "../components/DataDisplayOtrasFormas";
import logothe from "../img/logothe.png";
import DataFetcherNews from "../hooks/fetchNews";
import madrid from "../img/madrid.png";
import roma from "../img/roma.png";
import ny from "../img/nueva_york.png";
import quito from "../img/quito.png";
import guayaquil from "../img/guayaquil.png";
import cuenca from "../img/cuenca.png";
import { motion } from "framer-motion";
import PopUpTimer from "../components/PopUpTimer";
import PopUpBanner from "../components/PopUpBanner";
import SEO from "../components/SEO";
import imgseo from "../img/utplimg.jpg";
import Events from "../components/Events";
import DataFetcherCongresos from "../hooks/DataFetcherCongresos";
import Home from "../newPages/homenew/Home";

function NewHome() {
  const DataDisplayNovedades = ({ data }) => (
    <>
      <div className="layout9 padding">
        {" "}
        <div className="flex-center">
          <div className="width270">
            {" "}
            <h2>
              ¿Por qué estudiar <b>en la UTPL?</b>
            </h2>
            <p>
              Nuestros{" "}
              <b>más de 55 años de experiencia en formación universitaria</b> y
              más de 42 mil estudiantes matriculados de grado, posgrado,
              tecnologías y formación permanente avalan nuestra calidad
              académica y excelencia educativa.
            </p>{" "}
          </div>

          <div className="flex-start">
            {data.map((item, index) => (
              <div className="width270">
                <Card
                  src={"https://tec.utpl.edu.ec/" + item.field_image}
                  content={
                    <>
                      {" "}
                      <h3>{item.title}</h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_descripcion,
                        }}
                      />
                      <a
                        className="link-with-arrow"
                        target="_blank"
                        href={item.field_enlace}
                      >
                        Más información
                      </a>
                    </>
                  }
                ></Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <SEO
        title="¿Qué programas hay en la UTPL?"
        description="Te ofrecemos una amplia oferta académica. Revísala aquí"
        image={imgseo}
        url="https://utpl.edu.ec/"
      />{" "}
      <FixedHeader
        video="https://utpl.edu.ec/recursos/videos/utpl.mp4"
        src="https://utpl.edu.ec/recursos/img/cabecera-diciembre-2024.png"
        span="1"
        span0={
          <>
            Somos la
            <b> MEJOR</b>
          </>
        }
        span1="UNIVERSIDAD EN "
        span2={<> EDUCACIÓN EN LÍNEA</>}
        span3=" EN ECUADOR"
        span4={
          <div className="icon150-nomargin">
            <img src={logothe}></img>
          </div>
        }
      ></FixedHeader>

      <Home></Home>

   
      {/*
      <BlockRightImage
        content={
          <>
            <h2>
              Impulsa tu futuro con un{" "}
              <b>título UTPL válido en Estados Unidos</b>
            </h2>
            <p>
              Accede a mayores oportunidades laborales y obtén el reconocimiento
              profesional que fortalecerá tu perfil en el mercado laboral
              internacional.{" "}
            </p>
            <p><b>¡Con la UTPL el mundo está a tu alcance!</b></p>

            <a href="/validacion-internacional">Más información</a>
          </>
        }
        src="https://eventos.utpl.edu.ec/sites/default/files/images/img-titulo-valido.png"
      ></BlockRightImage>
       
      <img src={img1}></img>
     
      <div className="graybg wrapper-simulador">
        <BlockLeftImage
          src={data.videoTemplate.imageBlock7.url}
          alt={data.videoTemplate.imageBlock7.title}
          content={documentToReactComponents(
            data.videoTemplate.contentBlock7.json
          )}
        ></BlockLeftImage>
      </div>*/}
    
   
      <DataFetcherCongresos> </DataFetcherCongresos>
      {/*   <div className="padding">
        <DataFetcherNews url="https://noticias.utpl.edu.ec/parque/servicio-utpl.json"></DataFetcherNews>
      </div> */}
      <div className="icon300 graybg">
        <BlockLeftImage
          src="https://utpl.edu.ec/recursos/img/costos.gif"
          content={
            <>
              <h2>
                {" "}
                Simulador <b>de costos</b>
              </h2>
              <p>
                Aplica para estudiantes nuevos de carreras - tecnologías en
                línea y a distancia
              </p>
              <p>
                {" "}
                Explora los costos, las opciones de becas y variedad de
                descuentos diseñados para ti. ¡Haz tu matrícula ahora mismo y da
                el primer paso hacia una educación superior que se adapte a tus
                necesidades!
              </p>

              <a href="https://matriculas.utpl.edu.ec">Simular ahora</a>
            </>
          }
        ></BlockLeftImage>
      </div>
      <div className="bluebg padding ">
        <div className="wrapper-contactocentros layout8">
          <div>
            <h2>
              Contamos con +90 centros nacionales e internacionales
              estratégicamente ubicados
            </h2>
            <p></p>
            <p>Directorio de centros UTPL</p>

            <a
              target="_blank"
              rel="noreferrer"
              href="https://directorio.utpl.edu.ec/centros"
            >
              Revísalos aquí
            </a>
          </div>
          <div className="items-centros">
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.1,
                },
              }}
            >
              <img src={madrid} alt="utpl"></img>
              <div className="layout9">
                <h3> UTPL Centro Madrid</h3>
                <p>Ronda de Segovia, 50</p>
                <p>cimadrid@utpl.edu.ec</p>
                <p>(+34) 912618144</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.2,
                },
              }}
            >
              <img src={roma} alt="utpl"></img>
              <div className="layout9">
                <h3>UTPL Centro Roma</h3>
                <p>Via Selvaforte 10, 00148 Roma, Italia.</p>
                <p>ciroma@utpl.edu.ec</p>
                <p>(+39) 3381120872</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.3,
                },
              }}
            >
              <img src={ny} alt="utpl"></img>
              <div className="layout9">
                <h3> UTPL Centro Nueva York</h3>
                <p>
                  86-58 Midland Parkway, Jamaica Estates, N.Y. 11432, Nueva
                  York, Estados Unidos
                </p>
                <p>cinewyork@utpl.edu.ec</p>
                <p>(+1) 718-739-0060 o (+1) 718-739-0155</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.4,
                },
              }}
            >
              <img src={quito} alt="utpl"></img>
              <div className="layout9">
                <h3> UTPL Centro Quito</h3>
                <p> Av. 6 de diciembre y Alpallana </p>
                <p> crquito@utpl.edu.ec </p>
                <p>(02) 3947220</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.5,
                },
              }}
            >
              <img src={guayaquil} alt="utpl"></img>

              <div className="layout9">
                <h3> UTPL Centro Guayaquil</h3>
                <p>Av. Kennedy 333 entre Av. San Jorge y calle F</p>
                <p>informacioncrg@utpl.edu.ec</p>
                <p>(04) 2282084</p>
                <p> (04) 2282085</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.6,
                },
              }}
            >
              <img src={cuenca} alt="utpl"></img>
              <div className="layout9">
                <h3> UTPL Centro Cuenca</h3>
                <p>Av. Gran Colombia 22-167 y Unidad Nacional </p>
                <p> crcuenca@utpl.edu.ec</p>
                <p> (07) 3708000 ext 7021</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      <BannerGeneral></BannerGeneral>
      <PopUpTimer></PopUpTimer>
    </>
  );
}

export default NewHome;
